import { defineStore } from 'pinia'
import { useStorage } from '@vueuse/core'
// https://pinia.vuejs.org/cookbook/composables.html#SSR
export const useCartStore = defineStore('cartStore', {
  state: () => ({
    cart: useStorage('eleven-spectacles-cart', new Map())
  }),
  hydrate(state, initialState) {
    // in this case we can completely ignore the initial state since we
    // want to read the value from the browser
    state.cart = useStorage('eleven-spectacles-cart', new Map())
  },

  getters: {
    items: (cartStore) => [...cartStore?.cart.values()],
    stripeItems: (cartStore) =>
      cartStore.items.map((i) => {
        return { stripeProductId: i.stripeProductId, quantity: i.quantity }
      }),
    count: (cartStore) =>
      cartStore.items.reduce((a, c) => {
        return a + c.quantity
      }, 0),
    total: (cartStore) =>
      cartStore.items.reduce((a, c) => {
        const price = c?.attributes?.price ?? c?.product?.price ?? c?.price ?? 0
        return a + c.quantity * price
      }, 0)
  },

  actions: {
    add(product) {
      if (this.cart.has(product?.stripeProductId)) {
        this.cart.get(product?.stripeProductId).quantity++
      } else {
        this.cart.set(product?.stripeProductId, { ...product, quantity: 1 })
      }
    },
    remove(product) {
      if (this.cart.get(product?.stripeProductId).quantity > 1) {
        this.cart.get(product?.stripeProductId).quantity--
      } else {
        this.delete(product)
      }
    },
    delete(product) {
      if (this.cart.get(product?.stripeProductId)) {
        this.cart.delete(product?.stripeProductId)
      }
    }
  }
})
